import React, { useEffect } from "react";
import { X } from "lucide-react";
import { STATUS_META, TIPO_META, CATEGORIA_META } from "@/lib/constants";

export function Modal({ open, onClose, title, children, testid }) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4"
      data-testid={testid}
    >
      <div
        className="absolute inset-0 bg-[#0d2236]/45 backdrop-blur-sm animate-fadeup"
        onClick={onClose}
      />
      <div className="relative card-surface w-full sm:max-w-lg max-h-[90vh] overflow-y-auto rounded-t-3xl sm:rounded-2xl animate-fadeup">
        <div className="sticky top-0 bg-white/95 backdrop-blur border-b border-border flex items-center justify-between px-5 py-4 z-10">
          <h3 className="font-display text-2xl text-[#1F4E78]">{title}</h3>
          <button
            onClick={onClose}
            data-testid="modal-close-btn"
            className="p-1.5 rounded-full hover:bg-muted text-muted-foreground transition-colors"
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}

export function StatusBadge({ status }) {
  const m = STATUS_META[status] || STATUS_META.pendiente;
  return (
    <span
      className="chip inline-flex items-center gap-1.5"
      style={{ background: m.bg, color: m.fg }}
      data-testid={`status-badge-${status}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: m.dot }} />
      {m.label}
    </span>
  );
}

export function TipoBadge({ tipo }) {
  const m = TIPO_META[tipo] || TIPO_META.primera;
  return (
    <span className="chip" style={{ background: m.bg, color: m.color }}>
      {m.label}
    </span>
  );
}

export function CategoriaBadge({ categoria }) {
  if (!categoria) return null;
  const m = CATEGORIA_META[categoria] || CATEGORIA_META.otro;
  return (
    <span className="chip inline-flex items-center gap-1.5" style={{ background: m.bg, color: m.color }} data-testid={`categoria-badge-${categoria}`}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: m.color }} />
      {m.label}
    </span>
  );
}
